import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
// import { Message } from 'element-ui'
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { getUserAddLog } from '@/api/user';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, current, params, hasRoles, roles, cardChannelType, accessRoutes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          store.commit('settings/CLAER_CANCEL'); // 取消请求
          console.log(to, 'to');
          if (!(to.path == '/login' || to.path == '/openRonglian')) {
            _context.next = 6;
            break;
          }
          store.commit('user/RESET_STATE');
          next();
          return _context.abrupt("return");
        case 6:
          hasToken = getToken();
          if (to.query.token) {
            setToken(to.query.token);
            store.commit('user/SET_TOKEN', to.query.token);
          }
          // 没有token 直接跳转登陆页
          // 没有token 直接跳转登陆页
          // if (!getToken()) {     只有测试使用
          // if (!hasToken) {       线上使用这个
          if (getToken()) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", next({
            path: '/login'
          }));
        case 10:
          // start progress bar
          NProgress.start();
          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          // const hasToken = store.getters.token

          if (!store.getters.companyList.length) {
            // await store.dispatch('user/getCompanyList')
            //  await store.dispatch('user/getSellUsers')
            // await store.dispatch('user/getOperateUserList')
            // await store.dispatch('user/getOrganizeList')
          }
          if (store.getters.menus.length) {
            _context.next = 16;
            break;
          }
          _context.next = 16;
          return store.dispatch('user/getMenus');
        case 16:
          if (store.getters.head) {
            _context.next = 19;
            break;
          }
          _context.next = 19;
          return store.dispatch('user/getMyAvatar');
        case 19:
          if (store.getters.serviceName) {
            _context.next = 22;
            break;
          }
          _context.next = 22;
          return store.dispatch('user/getServiceName');
        case 22:
          current = store.getters.menus.find(function (item) {
            var children = item.children;
            if (children.findIndex(function (item2) {
              return item2.path === to.path;
            }) !== -1) {
              return item;
            }
          }); // 当前路由是否二级菜单中，记录日志
          if (current) {
            params = {
              path: to.path
            };
            getUserAddLog(params).then(function (res) {
              console.log('记录日志');
              // 获取缓存中的定时器并清除
              var localTimer = localStorage.getItem('largeScreenTimer');
              localTimer && clearInterval(localTimer);
              localTimer && localStorage.removeItem('largeScreenTimer');
            });
          }
          next();
          NProgress.done();
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 31;
            break;
          }
          next();
          _context.next = 42;
          break;
        case 31:
          _context.next = 33;
          return store.dispatch('user/getInfo');
        case 33:
          roles = _context.sent;
          _context.next = 36;
          return store.dispatch('user/getCardChannelType');
        case 36:
          cardChannelType = _context.sent;
          _context.next = 39;
          return store.dispatch('permission/generateRoutes', roles);
        case 39:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next();
        case 42:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});